import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WMSMPagesRoutingModule } from './WMSMPages-routing.module';
import { WMSM001Component } from './WMSM001/WMSM001.component';
import { WmsmHelpComponent } from './wmsm-help/wmsm-help.component';
import { WMSM002Component } from './WMSM002/WMSM002.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ShareModule } from '../shared/share-module.module';
import { NgZorroAntdModule } from 'src/app/ng-zorro-antd.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WMSMComponent } from './WMSM.component';
import { EditWMSM001Component } from './WMSM001/edit-wmsm001/edit-wmsm001.component';
import { WmsmFactorComponent } from './wmsm-Factor/wmsm-Factor.component';
import { Wmsm009Component } from './wmsm009/wmsm009.component';
import { AddProxySingleComponent } from './wmsm009/AddProxy-Single/AddProxy-Single.component';
import { AddProxyMultipleComponent } from './wmsm009/AddProxy-Multiple/AddProxy-Multiple.component';
import { AddProxyChangeComponent } from './wmsm009/AddProxy-Change/AddProxy-Change.component'
import { AddEditProxyComponent } from './wmsm009/add-edit-proxy/add-edit-proxy.component'
import { WmsmOnlineFileComponent } from './wmsm-OnlineFile/wmsm-OnlineFile.component'
import { WmsmIDApplicationComponent } from './wmsm-IDApplication/wmsm-IDApplication.component'
import { WmsmCaseCloseComponent } from './wmsm-CaseClose/wmsm-CaseClose.component'
import { NzImageModule } from 'ng-zorro-antd/image';
import { WmsmChangeHistoryComponent } from './wmsm-ChangeHistory/wmsm-ChangeHistory.component'
import { WmsmDowmloadSupplierListComponent } from './wmsm-DowmloadSupplierList/wmsm-DowmloadSupplierList.component'
import { WmsmAdminDowmloadSupplierListComponent } from './wmsm-AdminDowmloadSupplierList/wmsm-AdminDowmloadSupplierList.component'
import { WmsmRoleAccountsComponent } from './wmsm-RoleAccounts/wmsm-RoleAccounts.component'
import { WmsmStatementQueryComponent } from './wmsm-StatementQuery/wmsm-StatementQuery.component'
import { WmsmStatementMaintainComponent } from './wmsm-StatementMaintain/wmsm-StatementMaintain.component'
import { EditWmsmStatementMaintainComponent } from './wmsm-StatementMaintain/edit-wmsm-StatementMaintain/edit-wmsm-StatementMaintain.component'
import { WmsmStatementabnormalComponent } from './wmsm-Statementabnormal/wmsm-Statementabnormal.component'
import { EditWmsmStatementMaintainFxComponent } from './wmsm-StatementMaintain/edit-wmsm-StatementMaintain-fx/edit-wmsm-StatementMaintain-fx.component';
import { WmsmExcludevendorComponent } from './wmsm-excludevendor/wmsm-excludevendor.component';
import { EditExcludevendorComponent } from './wmsm-excludevendor/edit-excludevendor/edit-excludevendor.component'
import { WmsmStatementQueryWHQComponent } from './wmsm-StatementQueryWHQ/wmsm-StatementQueryWHQ.component'
import { WmsmStatementMaintainWHQComponent } from './wmsm-StatementMaintainWHQ/wmsm-StatementMaintainWHQ.component'
import { WmsmStatementAbnormalWHQComponent } from './wmsm-StatementabnormalWHQ/wmsm-StatementabnormalWHQ.component'
import { EditWmsmStatementMaintainWHQComponent } from './wmsm-StatementMaintainWHQ/edit-wmsm-StatementMaintainWHQ/edit-wmsm-StatementMaintainWHQ.component'
import { EditWmsmElectronicInvoice } from './wmsm-StatementMaintainWHQ/edit-wmsm-ElectronicInvoice/edit-wmsm-ElectronicInvoice.component';
import { EditWmsmManualInvoice } from './wmsm-StatementMaintainWHQ/edit-wmsm-ManualInvoice/edit-wmsm-ManualInvoice.component';
import { WmsmSiteAdminRoleComponent } from './wmsm-SiteAdminRole/wmsm-SiteAdminRole.component';
import { WmsmMaintenanceSystemBulletinComponent } from './wmsm-MaintenanceSystemBulletin/wmsm-MaintenanceSystemBulletin.component';
import { WmsmContractTemplateManagementComponent } from './wmsm-ContractTemplateManagement/wmsm-ContractTemplateManagement.component';
import { WmsmMailServiceManagementComponent } from './wmsm-MailServiceManagement/wmsm-MailServiceManagement.component';
import { WmsmModuleManagementComponent } from './wmsm-ModuleManagement/wmsm-ModuleManagement.component';
import { WmsmContractSendingComponent } from './wmsm-ContractSending/wmsm-ContractSending.component';
import { WmsmScheduleManagementComponent } from './wmsm-ScheduleManagement/wmsm-ScheduleManagement.component';
import { WmsmMenuManagementComponent } from './wmsm-menu-management/wmsm-menu-management.component';
import { WmsmRoleManagementComponent } from './wmsm-role-management/wmsm-role-management.component';
import { SourcingRequestSettingComponent } from './BaseData/sourcing-request-setting/sourcing-request-setting.component';
import { MroExpertSettingComponent } from './BaseData/mro-expert-setting/mro-expert-setting.component';
import { WmsmGuestVendorComponent } from './wmsm-GuestVendor/wmsm-GuestVendor.component';
import { WmsmRegisterVendor } from './wmsm-RegisterVendor/wmsmRegisterVendor.component';
import { MVMTestComponent } from './wmsm-mvmtest/mvmtest.component';


export function createTranslateHttpLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
  imports: [
    CommonModule,
    WMSMPagesRoutingModule,
    //I18N
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateHttpLoader,
        deps: [HttpClient],
      },
    }),
    ShareModule,
    NgZorroAntdModule,
    FormsModule,
    ReactiveFormsModule,
    NzImageModule,
  ],
  declarations: [
    WMSM001Component,
    WmsmHelpComponent,
    WMSM002Component,
    WMSMComponent,
    EditWMSM001Component,
    WmsmFactorComponent,
    Wmsm009Component,
    AddProxySingleComponent,
    AddProxyMultipleComponent,
    AddProxyChangeComponent,
    AddEditProxyComponent,
    WmsmOnlineFileComponent,
    WmsmIDApplicationComponent,
    WmsmCaseCloseComponent,
    WmsmChangeHistoryComponent,
    WmsmDowmloadSupplierListComponent,
    WmsmRoleAccountsComponent,
    WmsmStatementQueryComponent,
    WmsmStatementMaintainComponent,
    EditWmsmStatementMaintainComponent,
    EditWmsmStatementMaintainFxComponent,
    WmsmStatementabnormalComponent,
    WmsmExcludevendorComponent,
    EditExcludevendorComponent,
    WmsmStatementQueryWHQComponent,
    WmsmStatementMaintainWHQComponent,
    WmsmStatementAbnormalWHQComponent,
    EditWmsmStatementMaintainWHQComponent,
    EditWmsmElectronicInvoice,
    EditWmsmManualInvoice,
    WmsmAdminDowmloadSupplierListComponent,
    WmsmSiteAdminRoleComponent,
    WmsmMaintenanceSystemBulletinComponent,
    WmsmContractTemplateManagementComponent,
    WmsmMailServiceManagementComponent,
    WmsmModuleManagementComponent,
    WmsmContractSendingComponent,
    WmsmScheduleManagementComponent,
    WmsmMenuManagementComponent,
    WmsmRoleManagementComponent,
    SourcingRequestSettingComponent,
    MroExpertSettingComponent,
    WmsmGuestVendorComponent,
    WmsmRegisterVendor,
    MVMTestComponent
  ],
    exports: [
      WmsmFactorComponent,
      WmsmHelpComponent
    ],


})
export class WMSMPagesModule { }
